import { ReactiveFormHostState } from './reactive-form-host-state';

export interface ReactiveFormHostResettableRequest {
    reset(): void;
}

export interface ReactiveFormHostBackNavigationOptions<TModel> {
    readonly state: ReactiveFormHostState<TModel>;
    readonly pathToGoBack: string;
    readonly request?: ReactiveFormHostResettableRequest | null | undefined;
    readonly dashboardSegment?: string | undefined;
}

export interface ReactiveFormHostBackNavigation {
    readonly pathToGoBack: string;
    readonly commands: [string, string];
}

const defaultDashboardSegment = 'dashboard';

/** Resolves back-navigation state without knowing the application's router implementation. */
export class ReactiveFormHostNavigationState {
    public static setPath<TModel>(options: {
        readonly state: ReactiveFormHostState<TModel>;
        readonly pathToGoBack: string | null | undefined;
    }): string {
        const pathToGoBack = options.pathToGoBack ?? '';

        options.state.setNavigationPath(pathToGoBack);
        return pathToGoBack;
    }

    public static resolveBackTarget(pathToGoBack: string, dashboardSegment = defaultDashboardSegment): ReactiveFormHostBackNavigation {
        return {
            pathToGoBack,
            commands: [dashboardSegment, pathToGoBack],
        };
    }

    public static prepareBackNavigation<TModel>(options: ReactiveFormHostBackNavigationOptions<TModel>): ReactiveFormHostBackNavigation {
        options.request?.reset();

        const pathToGoBack = ReactiveFormHostNavigationState.setPath({
            state: options.state,
            pathToGoBack: options.pathToGoBack,
        });

        return ReactiveFormHostNavigationState.resolveBackTarget(pathToGoBack, options.dashboardSegment ?? defaultDashboardSegment);
    }
}
